import { AuxIcon } from "@blk/aladdin-react-components-es";
import Big from "big.js";
import React from "react";
import { getGainLossParameters } from "../indicator-helper";
import { numberFormatters } from "common";
import { areFiniteNumbers } from "common/number-helper";
import { NumberFormatKind } from "common/types";
const allowedDecimals = 0;
export const InsEsgVariationIndicator = ({ className, newValue, oldValue, signDisplay, variationSettings }) => {
    if (!areFiniteNumbers(oldValue, newValue)) {
        return React.createElement(React.Fragment, null);
    }
    const difference = new Big(newValue)
        .minus(oldValue)
        .round(allowedDecimals)
        .toNumber(), { iconState, iconType } = getGainLossParameters(difference, variationSettings.gainLoss), displayValue = numberFormatters(difference, NumberFormatKind.default, { maximumFractionDigits: 0, signDisplay });
    return React.createElement(React.Fragment, null,
        React.createElement("span", { className: "gain-loss-indicator" }, iconType && React.createElement(AuxIcon, { className: className, state: iconState, type: iconType })),
        React.createElement("span", { className: "variation-value" }, displayValue));
};
